import { useEffect, useRef, useState } from 'react';
import { connectAdminSocket, disconnectAdminSocket, type AdminSocket } from './socket.js';

/**
 * Protocole de reconnexion obligatoire : docs/05-websocket.md, section 9.
 * Identique au hook client, avec le jeton d'acces du personnel.
 */
export function useRealtimeSync(
  accessToken: string | null,
  resync: () => void,
): { socket: AdminSocket | null; connected: boolean } {
  const [socket, setSocket] = useState<AdminSocket | null>(null);
  const [connected, setConnected] = useState(false);
  const everConnected = useRef(false);
  const resyncRef = useRef(resync);
  resyncRef.current = resync;

  useEffect(() => {
    if (!accessToken) return;
    everConnected.current = false;
    const s = connectAdminSocket(accessToken);
    setSocket(s);

    const onConnect = () => {
      if (everConnected.current) resyncRef.current();
      everConnected.current = true;
      setConnected(true);
    };
    const onDisconnect = () => setConnected(false);

    s.on('connect', onConnect);
    s.on('disconnect', onDisconnect);

    return () => {
      s.off('connect', onConnect);
      s.off('disconnect', onDisconnect);
      disconnectAdminSocket();
      setSocket(null);
      setConnected(false);
    };
  }, [accessToken]);

  return { socket, connected };
}
